import React from 'react';
import './ResizableTableHeader.css';

/**
 * Header cell with Excel-style drag handle on the right edge.
 */
export function ResizableTh({
  columnId,
  onResizeMouseDown,
  children,
  resizable = true,
  className = '',
  ...thProps
}) {
  return (
    <th className={`th-resizable ${className}`.trim()} {...thProps}>
      <div className="th-resizable-label">{children}</div>
      {resizable && (
        <div
          className="column-resize-handle"
          onPointerDown={onResizeMouseDown(columnId)}
          onClick={(e) => e.stopPropagation()}
          role="separator"
          aria-orientation="vertical"
          aria-hidden="true"
        />
      )}
    </th>
  );
}
